import { render } from "./EventForm.vue?vue&type=template&id=51047028&scoped=true&ts=true"
import script from "./EventForm.vue?vue&type=script&lang=ts"
export * from "./EventForm.vue?vue&type=script&lang=ts"

import "./EventForm.vue?vue&type=style&index=0&id=51047028&lang=scss&scoped=true"
import "./EventForm.vue?vue&type=style&index=1&id=51047028&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51047028"]])

export default __exports__